import { createReferralLink } from './createReferralLink';
import { ReferralMedium } from './types';

export const createReferralWidgetLink = supplierName =>
  createReferralLink(supplierName, ReferralMedium.WIDGET);
